<template>
  <div>
    <v-card class="mx-auto" outlined>
      <v-list-item three-line>
        <v-list-item-content>
          <v-list-item-title class="headline mb-1">
            Query Options
          </v-list-item-title>

          <v-select
            v-model="select"
            :items="['Daily Deliveries', 'All Deliveries']"
            :rules="[v => !!v || 'Item is required']"
            label="Report Type"
            required
          ></v-select>

          <v-checkbox
            v-model="all_lines"
            label="All Shipping Lines"
          ></v-checkbox>
          <v-checkbox
            v-model="all_lines"
            label="By Shipping Lines"
          ></v-checkbox>

          <v-select
            v-model="select"
            :items="['Daily Deliveries', 'All Deliveries']"
            label="Shipping Lines"
          ></v-select>
        </v-list-item-content>
      </v-list-item>

      <v-card-actions>
        <v-btn depressed color="primary" @click="report_modal = true">
          Show Report
        </v-btn>
        <v-btn depressed color="error">Reset</v-btn>
      </v-card-actions>
    </v-card>
    <!-- report modal starts here -->
    <v-dialog v-model="report_modal" persistent max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">Report Viewer</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row> </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="report_modal = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: "ReportOptions",
  data: () => ({
    select: null,
    valid: true,
    all_lines: false,
    report_modal: false
  })
};
</script>
